var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "append-to-body": true,
        "close-on-click-modal": false,
        "show-close": true,
        title: _vm.$t("placeOrder.BatchExport"),
        visible: _vm.dialogVisibleExport,
        top: "10vh",
        width: "500px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisibleExport = $event
        },
        close: _vm.clearForm,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "exportOrderFormRef",
          staticClass: "demo-exporOrderForm",
          attrs: { model: _vm.exporOrderForm, "label-position": "top" },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                rules: {
                  required: true,
                  message: _vm.$t("placeOrder.pleaseInput"),
                  trigger: ["blur", "change"],
                },
                prop: "NumberType",
              },
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "60%" },
                  model: {
                    value: _vm.exporOrderForm.NumberType,
                    callback: function ($$v) {
                      _vm.$set(_vm.exporOrderForm, "NumberType", $$v)
                    },
                    expression: "exporOrderForm.NumberType",
                  },
                },
                [
                  _c("el-option", {
                    key: "1",
                    attrs: {
                      label: _vm.$t("orderCenterCont.anjunWaybillNumber"),
                      value: 1,
                    },
                  }),
                  _c("el-option", {
                    key: "2",
                    attrs: {
                      label: _vm.$t("GlobalSetObj.ScanNumber"),
                      value: 2,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticStyle: { width: "100%" },
              attrs: {
                rules: {
                  required: true,
                  message: _vm.$t("placeOrder.pleaseInput"),
                  trigger: ["blur"],
                },
                prop: "inputNumber",
              },
            },
            [
              _c("el-input", {
                attrs: {
                  placeholder: _vm.$t("mdfeTranslate.multipleLineInput"),
                  clearable: "",
                  rows: "6",
                  type: "textarea",
                },
                model: {
                  value: _vm.exporOrderForm.inputNumber,
                  callback: function ($$v) {
                    _vm.$set(_vm.exporOrderForm, "inputNumber", $$v)
                  },
                  expression: "exporOrderForm.inputNumber",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { "text-align": "right", margin: "15px 0" } },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  _vm.dialogVisibleExport = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("GlobalSetObj.Cancelar")) + " ")]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.comfireExport },
            },
            [_vm._v(_vm._s(_vm.$t("collectionCenter.CheckItOutNow")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }